<template>
  <form data-vv-scope="register">
    <!--FirstName-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.firstname)">
      <label
        class="control-label requiredField"
        for="vendorfirstname"
        data-test="vendorSignUpFirstName"
        id="vendorSignUpFirstName"
      >
        First Name
        <span class="asteriskField" data-test="vendorSignUpFirstNameSpan"
														id="vendorSignUpFirstNameSpan">*</span>
      </label>
      <input
        class="form-control"
        id="vendorfirstname"
        name="firstname"
        type="text"
        placeholder="First Name"
        v-model="account.firstname"
        v-validate="'required|min:3|alpha'"
        :class="(showSignUpError &&
                           errors.has('register.firstname'))?'is-invalid':''"
        :disabled="show"
        data-test="vendorSignUpFirstNameInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.firstname')"
        id="vendor-signup-firstname-error"
        data-test="vendorSignUpFirstNameError"
      >{{errors.first('register.firstname')}}</div>
    </div>

    <!--LastName-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.lastname)">
      <label
        class="control-label requiredField"
        for="vendorlastname"
        data-test="vendorSignUpLastName"
        id="vendorSignUpLastName"
      >
        Last Name
        <span class="asteriskField" data-test="vendorSignUpLastNameSpan"
														id="vendorSignUpLastNameSpan">*</span>
      </label>
      <input
        class="form-control"
        id="vendorlastname"
        name="lastname"
        type="text"
        placeholder="Last Name"
        v-model="account.lastname"
        v-validate="'required|min:3|alpha'"
        :class="(showSignUpError &&
                           errors.has('register.lastname'))?'is-invalid':''"
        :disabled="show"
        data-test="vendorSignUpLastNameInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.lastname')"
        id="vendor-signup-lastname-error"
        data-test="vendorSignUpLastNameError"
      >{{errors.first('register.lastname')}}</div>
    </div>

    <!--Email-->
    <div
      class="form-group"
      v-if="((fieldsToEnable.enableAll ||
                       fieldsToEnable.email)
                        && fieldNotEditable) ||
                       viewOrEdit === 'view'"
    >
      <label class="control-label requiredField" for="vendoremail" data-test="vendorSignUpEmail"
													id="vendorSignUpEmail">
        Email
        <span class="asteriskField" data-test="vendorSignUpEmailSpan"
														id="vendorSignUpEmailSpan">*</span>
      </label>
      <input
        class="form-control"
        id="vendoremail"
        name="vendorEmail"
        type="email"
        placeholder="Email"
        v-model="account.email"
        v-validate="'required|min:3|email'"
        :class="(showSignUpError &&
                           errors.has('register.vendorEmail'))?'is-invalid':''"
        :disabled="fieldDisable"
        data-test="vendorSignUpEmailInput"
      />
    </div>

    <!--UserName-->
    <div
      class="form-group"
      v-if="((fieldsToEnable.enableAll ||
                       fieldsToEnable.username)
                        && fieldNotEditable) ||
                           viewOrEdit === 'view'"
    >
      <label
        class="control-label requiredField"
        for="vendorusername"
        data-test="vendorSignUpUsrName"
        id="vendorSignUpUsrName"
      >
        User Name
        <span class="asteriskField" data-test="vendorSignUpUsrNameSpan"
														id="vendorSignUpUsrNameSpan">*</span>
      </label>
      <input
        class="form-control"
        id="vendorusername"
        name="username"
        type="text"
        placeholder="UserName"
        v-model="account.username"
        v-validate="'required|min:3|alpha'"
        :class="(showSignUpError &&
                           errors.has('register.username'))?'is-invalid':''"
        :disabled="show"
        autocomplete="off"
        data-test="vendorSignUpUsrNameInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.username')"
        id="vendor-signup-username-error"
        data-test="vendorSignUpUsrNameError"
      >{{errors.first('register.username')}}</div>
    </div>

    <!--GstIn-->
    <!--<div class="form-group "-->
    <!--v-if="(fieldsToEnable.enableAll || fieldsToEnable.gst_number)">-->
    <!--<label class="control-label requiredField" for="vendor-signup-gstin"-->
    <!--&gt;-->
    <!--GstIn-->
    <!--<span class="asteriskField">-->
    <!--*-->
    <!--</span>-->
    <!--</label>-->
    <!--<input v-validate="'required|min:15|max:15|regex:^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'"-->
    <!--type="text"-->
    <!--:class="(showSignUpError &&-->
    <!--errors.has('register.gstIn'))?'is-invalid':''"-->
    <!--class="form-control login-signup-input mt-2"-->
    <!--v-model="account.gst_number"-->
    <!--name="gstIn"-->
    <!--placeholder="GSTIN"-->
    <!--id="vendor-signup-gstin"-->
    <!--autocomplete="off"-->
    <!--data-ismobileonly="false"-->
    <!--:disabled="show"-->
    <!--&gt;-->
    <!--<div class="invalid-feedback"-->
    <!--v-if="showSignUpError"-->
    <!--v-show="errors.has('register.gstIn')"-->
    <!--id="vendor-gst-error"-->
    <!--&gt;-->
    <!--{{errors.first('register.gstIn')}}-->
    <!--</div>-->
    <!--</div>-->

    <div
      class="form-group"
      v-if="(fieldsToEnable.enableAll || fieldsToEnable.gst_number) && !show && !account.gst_number"
    >
      <label class="control-label requiredField" for="vendor-signup-gstin-select"
													data-test="vendorSignUpGstIn"
													id="vendorSignUpGstInLabel">
        GstIn
        <span class="asteriskField"
														data-test="vendorSignUpGstInSpan"
														id="vendorSignUpGstInSpan">*</span>
      </label>
      <select
        class="select form-control"
        id="vendor-signup-gstin-select"
        name="gstInSelect"
        style="text-transform: capitalize;"
        v-model="gstStatus"
        v-validate="'required|included:I have a GST No.,I don\'t have a GST No.'"
        :class="(showSignUpError &&
              errors.has('register.gstInSelect'))?'is-invalid':''"
        @change="gstOptionSelect"
								data-test="vendorSignUpGstInSelect"
      >
        <option disabled
																data-test="vendorSignUpGstInSelectOption"
																id="vendorSignUpGstInSelectOption">Select...</option>
        <option data-test="vendorSignUpGstInOption1"
																id="vendorSignUpGstInOption1">I have a GST No.</option>
        <option data-test="vendorSignUpGstInOption2"
																id="vendorSignUpGstInOption2">I don't have a GST No.</option>
      </select>
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.gstInSelect')"
        id="vendor-gst-select-error"
								data-test="vendorSignUpGstInSelectError"
      >{{errors.first('register.gstInSelect')}}</div>
    </div>
    <div class="form-group" v-if="showGstNoField || account.gst_number">
      <label
        class="control-label requiredField"
        for="vendor-signup-gstin"
        data-test="vendorSignUpGstNo"
        id="vendorSignUpGstNo"
      >
        GstNo.
        <span class="asteriskField" data-test="vendorSignUpGstNoSpan"
														id="vendorSignUpGstNoSpan">*</span>
      </label>
      <input
        v-validate="'required|min:15|max:15|regex:^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'"
        type="text"
        :class="(showSignUpError &&
                   errors.has('register.gstIn'))?'is-invalid':''"
        class="form-control login-signup-input mt-2"
        v-model="account.gst_number"
        name="gstIn"
        placeholder="Enter GSTIN"
        id="vendor-signup-gstin"
        autocomplete="off"
        data-ismobileonly="false"
        :disabled="show"
        data-test="vendorSignUpGstNoInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.gstIn')"
        id="vendor-gst-error"
        data-test="vendorSignUpGstNoError"
      >{{errors.first('register.gstIn')}}</div>
    </div>

    <!--GstNoCheckBox-->
    <div class="form-group" v-if="showGstNoCheckBox && !show">
      <label class="text-left d-block main_checkBoxcontainer"
													data-test="vendorSignUpGstNoCheckBox"
						>
        <input
          class="mr-2"
          name="checkbox"
          id="vendor-signUp-checkbox"
          :class="(showSignUpError &&
                           errors.has('register.checkbox'))?'is-invalid':''"
          type="checkbox"
          v-model="account.checkbox"
          autocomplete="off"
          v-validate="'required'"
										data-test="vendorSignUpGstNoCheckBoxInput"
        />
        Businesses with a turnover below Rs 20 lakh
        <span class="checkmark"></span>
      </label>
      <div
        class="invalid-feedback"
        style="display: block"
        v-if="showSignUpError"
        v-show="errors.has('register.checkbox')"
        id="vendor-checkbox-error"
								data-test="vendorSignUpGstNoCheckBoxError"
      >{{errors.first('register.checkbox')}}</div>
    </div>

    <!--SiteUrl-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.site_url)">
      <label
        class="control-label requiredField"
        for="vendor-signup-siteUrl"
        data-test="vendorSignUpUrl"
        id="vendorSignUpUrl"
      >
        SiteUrl(Optional)
        <!--<span class="asteriskField">-->
        <!--*-->
        <!--</span>-->
      </label>
      <input
        v-validate="'url'"
        type="text"
        :class="(showSignUpError &&
                           errors.has('register.siteUrl'))?'is-invalid':''"
        class="form-control login-signup-input mt-2"
        name="siteUrl"
        placeholder="Site Url"
        v-model="account.site_url"
        id="vendor-signup-siteUrl"
        autocomplete="off"
        data-ismobileonly="false"
        :disabled="show"
        data-test="vendorSignUpUrlInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.siteUrl')"
        id="vendor-siteUrl-error"
        data-test="vendorSignUpUrlError"
      >{{errors.first('register.siteUrl')}}</div>
    </div>

    <!--Password-->
    <div
      class="form-group"
      v-if="((fieldsToEnable.enableAll || fieldsToEnable.site_url) && showPassword)"
    >
      <label class="control-label requiredField" for="vendorpsswrd" data-test="vendorSignUpPsswrd"
													id="vendorSignUpPsswrd">
        Password
        <span class="asteriskField" data-test="vendorSignUpPsswrdSpan"
														id="vendorSignUpPsswrdSpan">*</span>
      </label>
      <input
        class="form-control"
        id="vendorpsswrd"
        name="password"
        type="password"
        placeholder="Password"
        v-model="account.password"
        v-validate="'required|min:6'"
        :class="(showSignUpError &&
                           errors.has('register.password'))?'is-invalid':''"
        :disabled="show"
        data-test="vendorSignUpPsswrdInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.password')"
        id="vendor-signup-password-error"
        data-test="vendorSignUpPsswrdError"
      >{{errors.first('register.password')}}</div>
    </div>

    <!--PhoneNumber-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.phone_number)">
      <label class="control-label requiredField" for="number" data-test="vendorSignUpPhnNo"
													id="vendorSignUpPhnNo">
        Phone Number
        <span class="asteriskField" data-test="vendorSignUpPhnNoSpan"
														id="vendorSignUpPhnNoSpan">*</span>
      </label>
      <input
        class="form-control"
        id="number"
        name="number"
        type="text"
        placeholder="Phone Number"
        v-model="account.phone_number"
        v-validate="'required|min:13|max:13|regex:^\\+[0-9]+$'"
        :class="(showSignUpError &&
                           errors.has('register.number')) || phnError ?'is-invalid':''"
        @blur="phoneCheck(account.phone_number)"
        :disabled="show"
        data-test="vendorSignUpPhnNoInput"
      />
      <div
        class="invalid-feedback"
        v-if="showSignUpError"
        v-show="errors.has('register.number')"
        id="vendor-RegisterForm-phone-phone-error"
        data-test="vendorSignUpPhnNoError1"
      >{{errors.first('register.number')}}</div>
      <div
        style="color: #dc3545"
        v-if="phnError"
        data-test="vendorSignUpPhnNoError2"
        id="vendorSignUpPhnNoError2"
      >CountryCode needed(eg. +91)</div>
    </div>

    <!--Adress Line 1-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.address_line1)">
      <label class="control-label requiredField" for="address1" data-test="vendorSignUpAddrss1"
													id="vendorSignUpAddrss1">
        Address Line 1
        <span class="asteriskField" data-test="vendorSignUpAddrss1Span"
														id="vendorSignUpAddrss1Span">*</span>
      </label>
      <input
        class="form-control"
        id="address1"
        name="address"
        type="text"
        placeholder="1234 Main St"
        v-validate="'required|min:3|max:20'"
        v-model="account.address_line1"
        :class="(showSignUpError &&
                    errors.has('register.address'))?'is-invalid':''"
        :disabled="show"
        data-test="vendorSignUpAddrss1Input"
      />
      <div
        class="invalid-feedback"
        v-if="(showSignUpError && errors.has('register.address'))"
        id="dlvry-adrs-line1-error"
        data-test="vendorSignUpAddrss1Error"
      >{{errors.first('register.address')}}</div>
    </div>

    <!--Adress Line 2-->
    <div class="form-group" v-if="(fieldsToEnable.enableAll || fieldsToEnable.address_line2)">
      <label class="control-label requiredField" for="address2" data-test="vendorSignUpAddrss2"
													id="vendorSignUpAddrss2">
        Address Line 2(Optional)
        <!--<span class="asteriskField">-->
        <!--*-->
        <!--</span>-->
      </label>
      <input
        class="form-control"
        id="address2"
        name="address2"
        type="text"
        placeholder="Apartment or suite"
        v-validate="'min:3|max:20'"
        v-model="account.address_line2"
        :disabled="show"
        :class="(showSignUpError &&
                           errors.has('register.address2'))?'is-invalid':''"
        data-test="vendorSignUpAddrss2Input"
      />
      <div
        class="invalid-feedback"
        v-if="(showSignUpError && errors.has('register.address2'))"
        id="dlvry-adrs-line2-error"
        data-test="vendorSignUpAddrs2Error"
      >{{errors.first('register.address2')}}</div>
    </div>

    <!--Country Selector-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.country) && !show)">
      <label for="vendor-signup-country" id="vendor-signup-country-heading"
													data-test="vendor-signup-country-heading">
        Country
        <span class="asteriskField"
														id="vendor-signup-country-Span"
														data-test="vendor-signup-country-Span">*</span>
      </label>
      <select
        @change="$forceUpdate()"
        class="custom-select d-block w-100"
        id="vendor-signup-country"
        name="country"
        v-validate="{ required: true }"
        v-model="account.country"
        :class="((showSignUpError && account.country === 'Select...') ||
          errors.has('register.country'))?'is-invalid':''"
								data-test="vendor-signup-country-Select"
      >
        <option disabled
																id="vendor-signup-country-Select-Option"
																data-test="vendor-signup-country-Select-Option">Select...</option>
        <option
          v-for="(country,index) in selectPicker(countryChoose)"
          :key="index"
          :id="'country'+index"
										:data-test="'vendor-signup-country-Select-Option1'+index"
        >{{country}}</option>
      </select>
      <div
        class="invalid-feedback"
        v-if="((showSignUpError && account.country === 'Select...') ||
          errors.has('register.country'))"
        id="dlvry-adrs-country-error"
								data-test="vendor-signup-country-Select-Error"
      >The country field required</div>
    </div>

    <!--View Country-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.country) && show)">
      <label class="control-label requiredField" for="view-signup-vendor-country"
													id="vendor-signup-country-View"
													data-test="vendor-signup-country-View">
        Country
        <span class="asteriskField"
														id="vendor-signup-country-ViewSpan"
														data-test="vendor-signup-country-ViewSpan">*</span>
      </label>
      <input
        class="form-control"
        id="view-signup-vendor-country"
        name="viewCountry"
        type="text"
        v-model="account.country"
        :disabled="show"
								data-test="vendor-signup-country-ViewInput"
      />
    </div>

    <!--State Selector-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.state) && !show)">
      <label for="vendor-signup-state" id="vendor-signup-state-heading"
													data-test="vendor-signup-state-heading">
        State
        <span class="asteriskField"
														id="vendor-signup-state-Span"
														data-test="vendor-signup-state-Span">*</span>
      </label>
      <select
        @change="$forceUpdate()"
        class="custom-select d-block w-100"
        id="vendor-signup-state"
        name="state"
        v-validate="{ required: true }"
        v-model="account.state"
        :class="((showSignUpError && account.state === 'Select...') ||
          errors.has('register.state'))?'is-invalid':''"
								data-test="vendor-signup-state-Select"
      >
        <option disabled
																id="vendor-signup-state-SelectOption"
																data-test="vendor-signup-SelectOption">Select...</option>
        <option
          v-for="(state,index) in selectPicker(countryChoose[account.country])"
          :key="index"
          :id="'state'+index"
										:data-test="'vendor-signup-state-Option'+index"
        >{{state}}</option>
      </select>
      <div
        class="invalid-feedback"
        v-if="((showSignUpError && account.state === 'Select...') ||
          errors.has('register.state'))"
        id="dlvry-adrs-state-error"
								data-test="vendor-signup-state-Error"
      >The state field required</div>
    </div>

    <!--View State-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.state) && show)">
      <label class="control-label requiredField" for="view-signup-vendor-state"
													id="vendor-signup-ViewState-heading"
													data-test="vendor-signup-Viewstate-heading">
        State
        <span class="asteriskField"
														id="vendor-signup-ViewState-Span"
														data-test="vendor-signup-Viewstate-Span">*</span>
      </label>
      <input
        class="form-control"
        id="view-signup-vendor-state"
        name="viewState"
        type="text"
        v-model="account.state"
        :disabled="show"
								data-test="vendor-signup-Viewstate-Input"
      />
    </div>

    <!--district-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.district) && !show)">
      <label for="vendor-sign-up-adrs-district" id="vendor-sign-up-adrs-district-heading"
													data-test="vendor-sign-up-adrs-district-heading">
        District
        <span class="asteriskField"
														id="vendor-sign-up-adrs-district-Span"
														data-test="vendor-sign-up-adrs-district-Span"
								>*</span>
      </label>

      <select
        @change="$forceUpdate()"
        class="custom-select d-block w-100"
        id="vendor-sign-up-adrs-district"
        name="district"
        v-validate="{ required: true }"
        v-model="account.district"
        :class="((showSignUpError && account.district === 'Select...') ||
          errors.has('register.district'))?'is-invalid':''"
								data-test="vendor-sign-up-adrs-district-Select"
      >
        <option disabled
																id="vendor-sign-up-adrs-district-Option"
																data-test="vendor-sign-up-adrs-district-Option">Select...</option>
        <option
          v-for="(district,index) in districtPickerData()"
          :key="index"
          :id="'district'+index"
										:data-test="'vendor-sign-up-adrs-district-Option'+index"
        >{{district}}</option>
      </select>
      <div
        class="invalid-feedback"
        v-if="((showSignUpError && account.district === 'Select...') ||
          errors.has('register.district'))"
        id="dlvry-adrs-district-error"
								data-test="vendor-sign-up-adrs-district-Error"
      >The district field required</div>
    </div>

    <!--View District-->
    <div class="form-group" v-if="((fieldsToEnable.enableAll || fieldsToEnable.district) && show)">
      <label class="control-label requiredField" for="view-signup-vendor-district"
													id="vendor-sign-up-adrs-Viewdistrict-heading"
													data-test="vendor-sign-up-adrs-Viewdistrict-heading">
        District
        <span class="asteriskField"
														id="vendor-sign-up-adrs-Viewdistrict-Span"
														data-test="vendor-sign-up-adrs-Viewdistrict-Span">*</span>
      </label>
      <input
        class="form-control"
        id="view-signup-vendor-district"
        name="viewDistrict"
        type="text"
        v-model="account.district"
        :disabled="show"
								data-test="vendor-sign-up-adrs-Viewdistrict-Input"
      />
    </div>

    <!--Proof of Identity-->
    <!--<div class="form-group "-->
    <!--v-if="((fieldsToEnable.enableAll || fieldsToEnable.identity_proof) && !show)">-->
    <!--<label class="control-label requiredField"-->
    <!--for="document-type-select"-->
    <!--&gt;-->
    <!--Proof of Identity-->
    <!--</label>-->
    <!--<select class="select form-control"-->
    <!--id="document-type-select"-->
    <!--name="documentTypeSelect"-->
    <!--style="text-transform: capitalize;"-->
    <!--v-model="account.identity_proof"-->
    <!--:class="(showSignUpError &&-->
    <!--errors.has('register.documentTypeSelect'))?'is-invalid':''"-->
    <!--&gt;-->
    <!--<option disabled>-->
    <!--Select...-->
    <!--</option>-->
    <!--<option v-for="(document, index) in getSelectedCountry.document_types"-->
    <!--:key="index"-->
    <!--:id="'document-upload-'+index"-->
    <!--&gt;-->
    <!--{{document}}-->
    <!--</option>-->
    <!--</select>-->
    <!--<div class="invalid-feedback"-->
    <!--v-if="showSignUpError"-->
    <!--v-show="errors.has('register.documentTypeSelect')"-->
    <!--id="vendor-RegisterForm-hostCountryName-error"-->
    <!--&gt;-->
    <!--{{errors.first('register.documentTypeSelect')}}-->
    <!--</div>-->
    <!--</div>-->

    <!--View Proof of Identity-->
    <!--<div class="form-group"-->
    <!--v-if="((fieldsToEnable.enableAll || fieldsToEnable.identity_proof) && show && account.identity_proof!=='Select...')">-->
    <!--<label class="control-label requiredField"-->
    <!--for="viewproof"-->
    <!--&gt;-->
    <!--Proof of Identity-->
    <!--<span class="asteriskField">-->
    <!--*-->
    <!--</span>-->
    <!--</label>-->
    <!--<input class="form-control"-->
    <!--id="viewproof"-->
    <!--name="viewproof"-->
    <!--type="text"-->
    <!--v-model="account.identity_proof"-->
    <!--:disabled="show"-->
    <!--/>-->
    <!--</div>-->

    <!--Upload-->
    <!--<div class="form-group "-->
    <!--v-if="((fieldsToEnable.enableAll || fieldsToEnable.documents) && !show)">-->
    <!--<label class="control-label requiredField">-->
    <!--Upload-->
    <!--</label>-->
    <!--<div class="input-group mb-3">-->
    <!--<div class="input-group-prepend">-->
    <!--<span class="input-group-text"-->
    <!--id="inputGroupFileAddon01"-->
    <!--&gt;-->
    <!--Upload-->
    <!--</span>-->
    <!--</div>-->
    <!--<div class="custom-file">-->
    <!--<input type="file"-->
    <!--name="fileupload"-->
    <!--class="custom-file-input"-->
    <!--id="inputGroupFile01"-->
    <!--accept="image/*"-->
    <!--v-validate="'ext:jpg,png,pdf'"-->
    <!--:class="(showSignUpError &&-->
    <!--errors.has('register.fileupload'))?'is-invalid':''"-->
    <!--@change="uploadImages"-->
    <!--aria-describedby="inputGroupFileAddon01"-->
    <!--&gt;-->
    <!--<label class="custom-file-label"-->
    <!--for="inputGroupFile01"-->
    <!--&gt;-->
    <!--{{this.fileName? this.fileName : 'Choose file'}}-->
    <!--</label>-->
    <!--<div class="invalid-feedback"-->
    <!--v-if="showSignUpError"-->
    <!--v-show="errors.has('register.fileupload')"-->
    <!--id="vendor-RegisterForm-fileUpload-error"-->
    <!--&gt;-->
    <!--{{errors.first('register.fileupload')}}-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--map-->
    <!--<div id="leaflet-map"-->
    <!--v-if="(fieldsToEnable.enableAll || fieldsToEnable.location)">-->
    <!--<label class="control-label requiredField"-->
    <!--v-show="viewOrEdit !== 'edit'"-->
    <!--&gt;-->
    <!--Choose Location-->
    <!--</label>-->
    <!--<div class="leaflet-map-wrapper"-->
    <!--v-if="location.latitude !== 400"-->
    <!--v-show="viewOrEdit !== 'edit'"-->
    <!--&gt;-->
    <!--<div id="map" style="width:100%; height:358px"></div>-->
    <!--</div>-->
    <!--</div>-->

    <div class="modal-footer" v-if="!show">
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="action('register')"
        data-test="vendorSignUpSubmitBtn"
        id="vendorSignUpSubmitBtn"
      >{{modalTexts.submitButton}}</button>
    </div>

    <div class="modal-footer" v-else>
      <button
        type="button"
        class="btn btn-primary"
        @click="$emit('signUpModalClose')"
        data-test="vendorSignUpCloseBtn"
        id="vendorSignUpCloseBtn"
      >Close</button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { vendorCommon } from '../../../../commonJs/vendorAndAgent'

const initialData = () => ({
	showSignUpError: false,
	gstStatus: 'Select...',
	showGstNoField: false,
	showGstNoCheckBox: false,
	gstRegex: '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$',
	account: {
		documents: '',
		identity_proof: 'Select...',
		country: 'Select...',
		state: 'Select...',
		district: 'Select...',
		checkbox: false
	},
	phnError: false,
	imageUploadUrl: {},
	fileName: '',
	/* Location Related Declarations */
	// location: {
	//   latitude: 400,
	//   longitude: 400,
	// },
	// selectedLocation: {},
	// locationList: [],
	/* Form list for New venodr Sign Up */
	newUserFieldList: {
		enableAll: true
	},
	/* Existing customer vendor signup */
	existingCustomerFieldList: {
		email: true,
		username: true,
		address_line1: true,
		address_line2: true,
		gst_number: true,
		site_url: true,
		documents: true,
		country: true,
		state: true,
		district: true,
		identity_proof: true
	},
	/* Form list for refer venodr */
	referVendorFieldList: {
		firstname: true,
		lastname: true,
		email: true,
		phone_number: true,
		address_line1: true,
		address_line2: true
	},
	countryChoose: {}
})
export default {
	computed: {
		...mapGetters('siteData', [
			'getSelectedCountry',
			'getCountriesWithShipping',
			'getShippingCountryDetails',
			'getTenantConfig'
		]),
		fieldDisable () {
			if (!this.referVendorForm) {
				if (!this.existingCustomerForm) {
					return this.viewOrEdit === '' || this.viewOrEdit === 'view'
				}
				return this.existingCustomerForm
			}
			return !this.referVendorForm
		},
		fieldsToEnable () {
			if (this.referVendorForm) {
				return this.referVendorFieldList
			} else if (this.existingCustomerForm) {
				return this.existingCustomerFieldList
			}
			return this.newUserFieldList
		},
		modalTexts () {
			const referVendorPageText = {
				modalTitle: 'Refer Vendor',
				submitButton: 'Refer'
			}
			const existingCustomerPageText = {
				modalTitle: 'Register',
				submitButton: 'Signup'
			}
			const newVendorPageText = {
				modalTitle: 'Register',
				submitButton: 'Save changes'
			}
			if (this.referVendorForm) {
				return referVendorPageText
			}
			if (this.existingCustomerForm) {
				return existingCustomerPageText
			}
			return newVendorPageText
		}
	},
	data () {
		return initialData()
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result && this.account.country !== 'Select...' && this.account.state !== 'Select...' && this.account.district !== 'Select...') {
					this.showSignUpError = false
					if (this.referVendorForm) {
						this.$emit('referVendor', this.account)
					} else if (this.existingCustomerForm) {
						this.$emit('existingCustomer', this.account)
					} else if (this.viewOrEdit === 'edit') {
						if (this.show === false && this.fieldNotEditable === false) {
							this.$emit('updateVendorInfo', this.account)
						}
						// else {
						//   this.$emit('vendorSignUp', this.account);
						//   // this.vendorSignup(this.account);
						// }
					} else {
						this.$emit('vendorSignUp', this.account)
					}
				} else {
					this.showSignUpError = true
				}
			})
		},
		districtPickerData () {
			if (this.countryChoose && this.countryChoose[this.account.country]) {
				return this.countryChoose[this.account.country][this.account.state]
			}
			return []
		},
		phoneCheck (phoneNumber) {
			const ph = phoneNumber.split('+')
			if (ph.length === 1) {
				this.phnError = true
			} else {
				this.phnError = false
			}
		},
		async uploadImages (event) {
			this.account.documents = await vendorCommon.imageUploader(event)
			if (this.account.documents !== '') {
				this.fileName = event.target.files[0].name
			}
		},
		signUpFormReferVendorFormClear () {
			this.account = {
				address_line1: '',
				address_line2: '',
				email: '',
				firstname: '',
				lastname: '',
				phone_number: ''
			}
		},
		gstOptionSelect () {
			this.showGstNoField = this.gstStatus === 'I have a GST No.'
			this.showGstNoCheckBox = this.gstStatus === "I don't have a GST No."
		},
		selectPicker (selectParentData) {
			if (selectParentData) {
				return Object.keys(selectParentData)
			}
			return []
		}
	},
	mounted () {
		this.$root.$on('vendorReferFormClear', () => {
			this.signUpFormReferVendorFormClear()
		})
		this.countryChoose = this.getShippingCountryDetails
		if (this.viewOrEdit === '') {
			// this.getVendorLocation();
		}
		if (this.vendorAccount !== undefined && this.vendorAccount !== null) {
			this.account = this.vendorAccount
		} else {
			this.account = {}
		}
		if (this.from === 'noVendorCustomer') {
			this.account = {
				email: this.email
			}
			if (!this.account.identity_proof) {
				this.account.identity_proof = 'Select...'
				this.account.country = 'Select...'
				this.account.state = 'Select...'
				this.account.district = 'Select...'
			}
		}
	},
	props: {
		email: null,
		from: null,
		vendorAccount: {},
		show: {
			type: Boolean,
			default: false
		},
		showPassword: {
			type: Boolean,
			default: true
		},
		viewOrEdit: {
			type: String,
			default: ''
		},
		fieldNotEditable: {
			type: Boolean,
			default: true
		},
		referVendorForm: {
			default: false,
			type: Boolean
		},
		existingCustomerForm: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		email () {
			if (this.from === 'noVendorCustomer') {
				this.account.email = this.email
			}
		},
		vendorAccount () {
			if (this.vendorAccount !== undefined && this.vendorAccount !== null) {
				this.account = this.vendorAccount
				this.account.username = this.vendorAccount.user_name
				this.account.email = this.vendorAccount.vendor_email
			}
		}
		// 'account.country': function () {
		//   this.account.countryData = JSON.parse(JSON.stringify(this.getCountriesWithShipping))
		//   .find(country => country.country_name === this.account.country);
		// },
	}
}
</script>
<style scoped>
/* The container */
</style>
